import type { LumpsumRebalanceCategory, LumpsumRebalanceBuyRecommendation } from '../../../../api/rebalance.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { RebalanceBuyFundCard } from '../cards/RebalanceBuyFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type RebalanceBuyBucketAccordionProps = {
  category: LumpsumRebalanceCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function RebalanceBuyBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: RebalanceBuyBucketAccordionProps) {
  const buyRecommendations = getCategoryBucketItems<LumpsumRebalanceBuyRecommendation>(category?.buyRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.REBALANCE,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.buyRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.buyRecommendations]}
      count={buyRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumRebalance,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.buyRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {buyRecommendations.map((recommendation, recommendationIndex) => (
        <RebalanceBuyFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < buyRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
